import React, { useState } from 'react';
import { getTranslation } from 'domain-model';
import LabelBadges from 'flaivy-react/components/LabelBadges';
import RequiresRole from 'flaivy-react/components/RequiresRole';
import PropTypes from 'prop-types';

import { Badge } from 'reactstrap';
import moment from 'moment';
import domainModel from 'domain-model';
import MetadataAlert from 'components/MetadataAlert';

function ArticleBadges({ entity }) {
  const { promoteAsNewStart, promoteAsNewEnd, _recentCreate } = entity;
  const viewModel = domainModel.article.getViewModel(entity);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = e => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };
  const published = [
    entity.isPublishedOnOurStore,
    entity.isPublishedOnPro,
    entity.isPublishedOnWhitelabel,
    entity.isPublishedOnStockfiller,
  ].filter(x => x);
  const publishedCount = published.length;

  return (
    <>
      {entity.metadata && (
        <RequiresRole requiredRoles={['super']}>
          <Badge className="me-1" onClick={toggle}>
            Har metadata
          </Badge>
        </RequiresRole>
      )}
      {entity.productCategory?.startsWith('Dryck|Vin') && (
        <Badge>
          {entity.vintage && 'År ' + entity.vintage + ' | '}
          {entity.grapes && entity.grapes + ' | '}
          {entity.region && viewModel.displayOrigin + ' | '}
          {viewModel.displayContainer && viewModel.displayContainer + ' | '}
          {entity.alcoholPercentage} % alk
        </Badge>
      )}
      {entity.active === false && (
        <Badge color="danger">Artikeln är inte aktiv</Badge>
      )}{' '}
      {entity.isCampaign && <Badge>Kampanj</Badge>}{' '}
      {(isOpen || publishedCount === 1) && entity.isPublishedOnOurStore && (
        <Badge onClick={toggle}>
          {getTranslation('article.isPublishedOnOurStore')}
        </Badge>
      )}{' '}
      {(isOpen || publishedCount === 1) && entity.isPublishedOnPro && (
        <Badge onClick={toggle}>
          {getTranslation('article.isPublishedOnPro')}
        </Badge>
      )}{' '}
      {(isOpen || publishedCount === 1) && entity.isPublishedOnWhitelabel && (
        <Badge onClick={toggle}>
          {getTranslation('article.isPublishedOnWhitelabel')}
        </Badge>
      )}{' '}
      {(isOpen || publishedCount === 1) && entity.isPublishedOnStockfiller && (
        <Badge onClick={toggle}>
          {getTranslation('article.isPublishedOnStockfiller')}
        </Badge>
      )}{' '}
      {!isOpen && publishedCount > 1 && (
        <Badge onClick={toggle}>Publicerad x{publishedCount}</Badge>
      )}{' '}
      {_recentCreate && <Badge>Ny artikel</Badge>}{' '}
      {entity.onCopack && <Badge>Co-pack artikel</Badge>}{' '}
      {entity.storageTemperature === 'refrigerated' && <Badge>Kylvara</Badge>}{' '}
      {entity.storageTemperature === 'frozen' && <Badge>Frysvara</Badge>}{' '}
      {entity.showInNews &&
        moment.utc().isBetween(promoteAsNewStart, promoteAsNewEnd) && (
          <Badge color="success">Nyhet</Badge>
        )}{' '}
      {entity.hasBatchWithExpiredDate && (
        <Badge color="danger">Gamla artiklar på lager</Badge>
      )}{' '}
      {entity.hasBatchWithShortDate && (
        <Badge color="warning">Artiklar med kort datum</Badge>
      )}{' '}
      {entity.requiresAlcoholPermit && (
        <Badge color="danger">Artikeln kräver alkoholtillstånd</Badge>
      )}{' '}
      {entity.systembolagetArticleNumber && (
        <Badge>Har systembolagetnummer</Badge>
      )}{' '}
      {entity.expiring && <Badge color="danger">Artikeln är utgående</Badge>}
      {entity.hasLongerDeliveryTime && <Badge>Beställningsvara</Badge>}{' '}
      {entity.labels && <LabelBadges value={entity.labels} />}{' '}
      {entity.metadata && isOpen && (
        <RequiresRole requiredRoles={['super']}>
          <MetadataAlert metadata={entity.metadata}></MetadataAlert>
        </RequiresRole>
      )}
    </>
  );
}
ArticleBadges.propTypes = {
  entity: PropTypes.object.isRequired,
};
export default ArticleBadges;
